module.exports = __webpack_public_path__ + "img/ltkworkwear-3x.6f992b8.jpg";